export const myOrgInternTranslations = {
  lv: {
    title: 'Mani praktikanti',
    group: 'Praktikanti',
    description:
      'Praktikanti, kuriem šajā prakses vietā esat vadītājs. Kolēģu praktikanti šeit nav redzami. Sarakstā ir arī prakses, kas beigušās pēdējo 60 dienu laikā.',
    count_one: '{{count}} praktikants',
    count_other: '{{count}} praktikanti',
    search: 'Meklēt pēc vārda vai uzvārda…',
    status: 'Prakses statuss',
    statuses: {
      all: 'Visi praktikanti',
      ongoing: 'Aktīvās prakses',
      upcoming: 'Gaidāmās prakses',
      ended: 'Bijušie praktikanti',
    },
    columns: {
      intern: 'Praktikants',
      eduOrg: 'Izglītības iestāde',
      internship: 'Prakse',
      date: 'Periods',
      hours: 'Stundas',
      agreement: 'Līgums',
    },
    filters: 'Filtri',
    apply: 'Filtrēt',
    clear: 'Notīrīt',
    activeFilters: 'Aktīvie filtri:',
    noOptions: 'Nav atrastu ierakstu',
    unavailable: 'Šie dati vēl nav pieejami.',
    availability: 'Stundu izpildes un līguma statusa dati vēl nav pieejami.',
    limit:
      'Vienlaikus pieejami pirmie {{count}} no {{total}} atrastajiem praktikantiem. Filtri un kārtošana attiecas uz šo kopu. Lai atrastu pārējos, precizējiet meklēšanu pēc vārda vai uzvārda.',
    incomplete: 'Dažu praktikantu prakses dati nav pieejami. Sarakstā saglabāti viņu vārdi.',
    loadError: 'Neizdevās ielādēt praktikantus',
    empty: 'Nav atrastu praktikantu',
    emptyBody: 'Pamēģiniet citu meklējumu vai notīriet filtrus.',
    download: 'Lejupielādēt dienasgrāmatu (PDF)',
    downloadError: 'Neizdevās lejupielādēt dienasgrāmatu. Mēģiniet vēlreiz.',
    actionsFor: 'Darbības: {{name}}',
  },
  en: {
    title: 'My interns',
    group: 'Interns',
    description:
      'Interns you supervise at this workplace. Colleagues’ interns are not shown here. Internships that ended within the last 60 days are also included.',
    count_one: '{{count}} intern',
    count_other: '{{count}} interns',
    search: 'Search by first or last name…',
    status: 'Internship status',
    statuses: {
      all: 'All interns',
      ongoing: 'Active internships',
      upcoming: 'Upcoming internships',
      ended: 'Former interns',
    },
    columns: {
      intern: 'Intern',
      eduOrg: 'Educational institution',
      internship: 'Internship',
      date: 'Period',
      hours: 'Hours',
      agreement: 'Agreement',
    },
    filters: 'Filters',
    apply: 'Apply',
    clear: 'Clear',
    activeFilters: 'Active filters:',
    noOptions: 'No results',
    unavailable: 'These data are not available yet.',
    availability: 'Hour progress and agreement status are not available yet.',
    limit:
      'This list includes the first {{count}} of {{total}} matching interns. Filters and sorting apply to this set. Refine the first or last name search to find other interns.',
    incomplete: 'Some placement details are unavailable. Intern names remain in the list.',
    loadError: 'Could not load interns',
    empty: 'No interns found',
    emptyBody: 'Try another search or clear the filters.',
    download: 'Download diary (PDF)',
    downloadError: 'Could not download the diary. Please try again.',
    actionsFor: 'Actions: {{name}}',
  },
}
